<template>
    <b-container
            fluid
            class="property-search-content"
            :class="{
            'px-0': isMobile,
        }"
    >
        <div
                v-if="isMobile && !isSavedSearchesDisplayed"
                class="toggle-buttons-holder"
                :class="{
              'w-75': tabDisplay,
              'max-w27': tabDisplay
          }"
        >
            <div
                    v-if="tabDisplay"
            >
                <property-saved-searches-save-button
                        class="w-auto"
                        v-if="filterable"
                />

                <property-search-content-listing-mode-toggle
                        :style="filter.isSold ? { 'width' : '-webkit-fill-available' } : {'width' : 'unset'}"
                        :render-map="renderMap"
                        @toggle="toggleMap"
                />
            </div>
            <b-button
                    v-else
                    block
                    variant="transparent"
                    size="lg"
                    class="get-started-btn py-3 w-100"
                    @click="getStartedPublic"
            >
                Get started
            </b-button>
        </div>
        <property-start-searching
                v-if="tabDisplay && isStartSearchDisplayed"
                :label="startSearchingOptions"
        />
        <b-row v-else-if="isMapDisplayed">
            <template v-if="toggleable">
                <b-col>
                    <property-search-content-listing-toggleable
                            :favorite-option-enabled="favoriteOptionEnabled"
                            :render-map="renderMap"
                            :is-map-hidden-by-visibility-only="isMapHiddenByVisibilityOnly"
                            :property-details-route="propertyDetailsRoute"
                            :location="location"
                            :tab-display="tabDisplay"
                            :map-config="mapConfig"
                            :content-height="contentHeight"
                            @toggle="toggleMap"
                    />
                </b-col>
            </template>

            <template v-else>
                <b-col
                        class="px-0"
                        cols="12"
                        :md="isTablet ? '9' : '7'"
                        :lg="betweenTabletAndLargeDesktop ? '9' : '6'"
                        :class="{
                        'favorites-map': tabDisplay && isFavoritesTab,
                        'mobile-map': isMobile,
                        'map-hidden-by-visibility-only': isMapHiddenByVisibilityOnly,
                    }"
                        v-show="!isMobile || renderMap || isMapHiddenByVisibilityOnly"
                >
                    <property-search-map
                            :location="location"
                            :property-details-route="propertyDetailsRoute"
                            :favorite-option-enabled="favoriteOptionEnabled"
                            :map-config="mapConfig"
                            :content-height="contentHeight"
                    />
                </b-col>
                <b-col
                        class="pl-md-0 pr-0"
                        cols="12"
                        :md="isTablet ? '3' : '5'"
                        :lg="betweenTabletAndLargeDesktop ? '3' : '6'"
                        v-show="!isMobile || !renderMap || isMapHiddenByVisibilityOnly"
                >
                    <property-listing
                            :property-details-route="propertyDetailsRoute"
                            :favorite-option-enabled="favoriteOptionEnabled"
                            :display-info-cards="!tabDisplay"
                            :class="{'pt-2': isTablet || isMobile}"
                            :content-height="contentHeight"
                    />
                </b-col>
            </template>
        </b-row>
        <b-row
                v-if="tabDisplay && isSavedSearchesDisplayed"
        >
            <b-col
                    :class="{
                    'px-0': isMobile
                }"
            >
                <property-saved-searches />
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import './PropertySearchContent.scss';
    import PropertyStartSearching from "../PropertySearchStartSearching";
    import PropertySearchMap from "../PropertySearchMap/PropertySearchMap";
    import PropertyListing from "../../GroupPropertyListing/PropertyListing/PropertyListing";
    import {
        PROPERTY_SEARCH_MAP_TOGGLE,
        PROPERTY_SEARCH_MAP_DISPLAY,
        PROPERTY_SEARCH_SAVED_SEARCHES_DISPLAY,
        PROPERTY_SEARCH_START_SEARCHING_DISPLAY,
        PROPERTY_SEARCH_DISABLED_OPTION,
    } from '../../GroupPropertySearchHeader/PropertySearchHeader/PropertySearchHeader';
    import {TABS} from '../../GroupPropertySearchHeader/PropertySearchHeader/PropertySearchHeader';
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import {SEARCH_TABS} from '../../../../helpers/variables';
    import PropertySearchContentListingModeToggle
        from "./PropertySearchContentListingModeToggle/PropertySearchContentListingModeToggle";
    import PropertySearchContentListingToggleable
        from "./PropertySearchContentListingToggleable/PropertySearchContentListingToggleable";
    import {proxyFilter} from "../../../classes/Filter";

    export default {
        name: 'PropertySearchContent',

        components: {
            PropertySearchContentListingToggleable,
            PropertySearchContentListingModeToggle,
            PropertyListing,
            PropertySearchMap,
            PropertySavedSearches: () => import(
                    "../../GroupPropertySavedSearches/PropertySavedSearches"
                    ),
            PropertySavedSearchesSaveButton: () => import(
                    "../../GroupPropertySavedSearches/PropertySavedSearchesSaveButton/PropertySavedSearchesSaveButton"
                    ),
            PropertyStartSearching,
        },

        mixins: [
            IsMobileMixin
        ],

        props: {
            propertyDetailsRoute: {
                type: [String, Object],
                default: 'property.details.view',
            },
            tabDisplay: {
                type: Boolean,
                default: true,
            },
            defaultLocationOverwrite: {
                type: Array,
                default: () => [],
            },
            favoriteOptionEnabled: {
                type: Boolean,
                default: true,
            },
            filterable: {
                type: Boolean,
                default: true,
            },
            toggleable: {
                type: Boolean,
                default: false,
            },
            mapConfig: {
                type: Object,
                default: () => {
                    return {};
                }
            },
        },

        data() {
            return {
                isStartSearchDisplayed: false,
                isMapDisplayed: true,
                isSavedSearchesDisplayed: false,
                renderMap: true,
                location: this.defaultLocationOverwrite,
                noResultSavedSearchImagePath: require('../../GroupPropertySavedSearches/saved_searches.png'),
                noResultFavoritesImagePath: require('../../GroupPropertyListing/empty_favorites.png'),
                filter: proxyFilter,
                contentHeight: 0,
            };
        },

        computed: {
            isMapHiddenByVisibilityOnly() {
                // when directly searching by a given center map point or by a location coord vector
                // if the map is hidden by display:none on first page load
                // gmaps will calculate the req map boundries wrong
                // & on landing pages we need to display the listing of proprieties first;

                return this.isMobile && !this.renderMap;
            },
            isFavoritesTab() {
                return String(this.$route.query.tab) === String(TABS.FAVORITE);
            },
            startSearchingOptions() {
                if (this.isSavedSearchesDisplayed) {
                    return {
                        'imagePath': this.noResultSavedSearchImagePath,
                        'text': 'You haven\'t saved any searches yet.',
                    };
                }
                if (this.isFavoritesTab) {
                    return {
                        'imagePath': this.noResultFavoritesImagePath,
                        'text': 'You haven\'t saved any favorites yet.',
                    };
                }
                return {
                    'imagePath': false,
                    'text': false,
                };
            },
            betweenTabletAndLargeDesktop() {
                return this.windowWidth > 768 && this.windowWidth < 1032;
            }
        },

        beforeMount() {
            this.renderMap = !this.isMobile;
            if (this.tabDisplay) {
                this.$bus.$on(PROPERTY_SEARCH_SAVED_SEARCHES_DISPLAY, this.displaySavedSearches);
                this.$bus.$on(PROPERTY_SEARCH_START_SEARCHING_DISPLAY, this.displayStartSearching);
            }
            this.$bus.$on(PROPERTY_SEARCH_MAP_TOGGLE, this.toggleMap);
            this.$bus.$on(PROPERTY_SEARCH_MAP_DISPLAY, this.displayMap);
        },

        mounted() {
            const headerObserver = new ResizeObserver(() => {
                this.calculateContentHeight();
            });

            headerObserver.observe(document.querySelector("#property-search-header"));
        },

        beforeDestroy() {
            if (this.tabDisplay) {
                this.$bus.$off(PROPERTY_SEARCH_SAVED_SEARCHES_DISPLAY, this.displaySavedSearches);
                this.$bus.$off(PROPERTY_SEARCH_START_SEARCHING_DISPLAY, this.displayStartSearching);
            }
            this.$bus.$off(PROPERTY_SEARCH_MAP_TOGGLE, this.toggleMap);
            this.$bus.$off(PROPERTY_SEARCH_MAP_DISPLAY, this.displayMap);
        },

        methods: {
            calculateContentHeight() {
                const el = document.querySelector("#property-search-header");
                this.contentHeight = el?.offsetHeight || 0;
            },
            getStartedPublic() {
                this.$bus.$emit(PROPERTY_SEARCH_DISABLED_OPTION);
            },
            toggleMap(forceValue = null) {
                this.renderMap = "boolean" === typeof (forceValue) ? forceValue : !this.renderMap;
            },
            displayStartSearching() {
                this.isStartSearchDisplayed = !!this.startSearchingOptions.text && !!this.startSearchingOptions.imagePath;
                if (this.isStartSearchDisplayed) {
                    this.isMapDisplayed = false;
                } else {
                    this.displayMap();
                }
            },
            displaySavedSearches() {
                this.isStartSearchDisplayed = false;
                this.isMapDisplayed = false;
                this.renderMap = true;
                this.isSavedSearchesDisplayed = true;
                this.location = [];
            },
            displayMap(location = []) {
                this.location = location && location.length
                    ? location
                    : this.defaultLocationOverwrite;
                this.isStartSearchDisplayed = false;
                this.isMapDisplayed = true;
                this.renderMap = true;
                this.isSavedSearchesDisplayed = false;
            },
        },
        watch: {
            '$route.query': {
                handler: function (newValue, oldValue) {
                    if (newValue.hasOwnProperty('searchTab') && this.isMobile) {
                        if (newValue.searchTab === SEARCH_TABS.LIST) {
                            this.renderMap = false;
                        }
                    }
                },
                deep: true,
                immediate: true
            }
        }
    };
</script>
